<div class="columns small-12 medium-6" data-masonry-item="">
  <ng-container *ngIf="isPending$ | async">
    <div class="rs-panel-flex">
      <div class="rs-panel-flex-cell rs-bg-grey1">
        <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
          <div class="rs-flex-column">
            <div
              class="panel rs-wd-s19 rs-wd-m15 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
        </div>
        <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
          <div class="rs-flex-column">
            <div
              class="panel rs-wd-s19 rs-wd-m30 rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
            <div
              class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
        </div>
        <div class="rs-flex-row rs-flex-middle rs-maxh rs-justify-right">
          <div class="rs-flex-column">
            <div
              class="panel rs-wd-s19 rs-wd-m30 rs-h-s4 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
          <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
            <div
              class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="simData$ | async as simData">
    <ng-container
      *ngIf="
        simData.activationToken && simData.activationCode && simData.subscriptionManagerURL && showESimContent;
        else simAndPuk
      ">
      <mprd-e-sim-qr-code
        (eSimPanelExpandedEventEmitter)="refreshInceptionEventEmitter.emit()"
        [eSimData]="simData"
      ></mprd-e-sim-qr-code>
    </ng-container>
    <ng-template #simAndPuk>
      <mprd-sim-and-puk [simInfo]="simData"></mprd-sim-and-puk>
    </ng-template>
  </ng-container>

  <div *ngIf="hasError$ | async" class="panel rs-bg-grey1 clearfix">
    <px-alert
      [alerts]="[
        {
          type: 'error',
          description: 'mobile.pricingPlan.simInfo.error' | translate,
          isClosable: false,
          taggingErrorType: 'backend'
        }
      ]"
    ></px-alert>
  </div>
</div>
